import { Injectable, signal } from '@angular/core';
import { darkTheme, lightTheme } from 'src/assets/styles/Themes';
import cssVars from 'css-vars-ponyfill';
import { ITheme } from '../interfaces/ITheme';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  public readonly mode = signal<'light' | 'dark'>(['dark', '"dark"'].includes(localStorage.getItem('theme') ?? '') ? 'dark' : 'light');

  public setTheme(mode: 'light' | 'dark'): void {
    this.mode.set(mode);
    const variables = this.getThemeVariables(mode);
    this.setColorVariables(variables);
  }

  private getThemeVariables(mode: 'light' | 'dark'): ITheme {
    if (mode === 'dark') {
      return darkTheme;
    } else {
      return lightTheme;
    }
  }

  private setColorVariables(colorPalette: ITheme): void {
    cssVars({
      variables: {
        ...colorPalette,
      },
    });
  }
}
